import styled from "styled-components";

export const GoldTitle = styled.div`
  text-align: center;
  font-size: 2rem;
  width: 100%;
  color: #a48559;
`;
